module.exports = __webpack_public_path__ + "static/media/f1.846932d2.jpg";